import One from '../images/one.png';
import Talker from '../images/talker.png';
import Blogs from '../images/blogs.png';
import Smith from '../images/smith.png';

export const DataBackEnd = [
  {
    name: 'TrybeSmith',
    image: Smith,
    github: "https://github.com/anaualima/trybe-smith",
    description: 'O projeto Trybe Smith cria um CRUD de itens medievais no formato de uma API, utilizando typescript. Resultando em endpoints para escrever e ler os dados através do MYSQL',
  },
  {
    name: 'Blogs Api',
    image: Blogs,
    github: "https://github.com/anaualima/blogs-api",
    description: 'O projeto Blogs API é a criação de uma API, com models através do sequelize, aplicando CRUD com ORM. Resultando em edpoints para consumo.',
  },
  {
    name: 'Talker Manager',
    image: Talker,
    github: "https://github.com/anaualima/talker-manager",
    description: 'Talker Manager é um projeto que constroi uma API, realizando operações assincronas com callbacks e promises. Utiliza Node.js e express.',
  },
  {
    name: 'Mysql One for all',
    image: One,
    github: "https://github.com/anaualima/mysql-one-for-all",
    description: 'O projeto One for all faz a modelagem de um banco de dados com mysql e javascript.',
  },
];
